import { deLocalizeUrl } from '$lib/paraglide/runtime';

import '$lib/arch/otel/Instrumentation';

import '$lib/arch/form/YupExtensions';

export const reroute = (request) => deLocalizeUrl(request.url).pathname;
